declare namespace $ {

	type $exso_table__items_exso_sheets_device_1 = $mol_type_enforce<
		ReturnType< $exso_sheets_device['shifts'] >
		,
		ReturnType< $exso_table['items'] >
	>
	type $exso_table__Title_exso_sheets_device_2 = $mol_type_enforce<
		any
		,
		ReturnType< $exso_table['Title'] >
	>
	type $exso_table__reverse_exso_sheets_device_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $exso_table['reverse'] >
	>
	type $exso_table__columns_exso_sheets_device_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $exso_table['columns'] >
	>
	type $exso_table__columns_meta_exso_sheets_device_5 = $mol_type_enforce<
		ReturnType< $exso_sheets_device['columns_meta'] >
		,
		ReturnType< $exso_table['columns_meta'] >
	>
	export class $exso_sheets_device extends $mol_page {
		all_shifts( ): readonly($exso_sheets_shift)[]
		shifts( ): ReturnType< $exso_sheets_device['all_shifts'] >
		columns_meta( ): Record<string, any>
		Shifts( ): $exso_table
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=device.view.tree.d.ts.map